/**
 * @fileoverview Component for showing progress while submitting configuration to the backend.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {LISTINGS_ASSET} from '/ui/components/marketingactivationpage/images/listings';
import {MarketingActivationPage} from '/ui/components/marketingactivationpage/marketingactivationpage';

import * as styles from '/src/com/yext/listingslaunchstorm/js/enterprise/launchprogress/launchprogress.module.scss';

/** @returns {React.ReactNode} */
export function LaunchProgress({status}) {
  let progressValue = 0;
  if (status === 'loading') {
    progressValue = 50;
  } else if (status === 'success') {
    progressValue = 100;
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <MarketingActivationPage
          image={LISTINGS_ASSET}
          header={yext.msg('Launching...')}
          description={yext.msg('The Listings Launch finalization may take a few minutes. Please wait and do not close this window as it loads.')}
          progressBarValue={progressValue}
        />
      </div>
    </div>
  );
}
